import React, { useState } from "react";
import { Platform, StatusBar, View } from "react-native";
import styles from "../../../styles/profileStyle";
import * as Location from 'expo-location';
import { useNavigation } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";

import {
  updateData,
  updateDataImage,
} from "../../../../../services/Profile/profileService";
import { PROFILE_ROUTES } from "../../../../../navigation/routes";
import TopIconView from "../../../../Auth/components/TopIconView";
import OnBoardingIcons from "../../../../../assets/Icons/OnBoardingIcons";
import TextView from "../../../../../components/CustomComponent/TextView";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import BottomView from "../../../../../components/GlobalComponents/BottomView";
import OptionCheckbox from "../../../components/OptionCheckbox";
import { handleBackButton } from "../../../components/BackButtonAlert";
import { useBackButtonHandler } from "../../../hooks/useBackHandler";
import { Colors } from "../../../../../globalStyles/ColorConfig";

const LikeToDate = () => {
  const navigation = useNavigation();
  useBackButtonHandler(handleBackButton, [navigation]);

  const [selectedOptions, setSelectedOptions] = useState([
    { label: "Male", state: false },
    { label: "Female", state: false },
    { label: "Other", state: false },
  ]);

  const handleCheckboxChange = (index: number) => {
    const updatedOptions = [...selectedOptions];
    updatedOptions[index].state = !updatedOptions[index].state;
    setSelectedOptions(updatedOptions);
  };

  async function nextButtonHandle() {

    const { granted }  = await Location.getForegroundPermissionsAsync();

    const selectedGenders = selectedOptions
      .filter((option) => option.state)
      .map((option) => option.label);

    const preference = { gender: selectedGenders };

    const updateUser = {
      preferences: preference,
      steps: 9,
    };

    const response = await updateData(updateUser);
    const res2 = await updateDataImage(updateUser);
    const screen = granted ? PROFILE_ROUTES.ONBOARD_ALLDONE : PROFILE_ROUTES.ONBOARD_GRANTACCESS
    navigation.navigate(screen as never);
  }



  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: "#ffffff",
        paddingTop: 30 
      }}
    >
      <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
      <View
        style={{
          flex: 1,
          paddingHorizontal: 25,
          gap: 16
        }}
      >
        {/* <TopIconView
          icon={<OnBoardingIcons.ProfileIconOnboarding />}
          totalScreens={4}
          currentScreen={2}
        /> */}
        <View style={{display:'flex',width:'100%',justifyContent:'center',alignItems:'center'}}>
                <TopIconView
                icon={<OnBoardingIcons.ProfileIconOnboarding />}
                currentScreen={10}
                totalScreens={10}
          /></View>
        <View style={{gap:10}}> 
          <TextView
            title="Who would like to date to?"
            textStyle={[
              GlobalStyles.heading3,
              {
                fontFamily: "EBGaramondSemiBold",
                fontSize: 34,
                lineHeight: 37,
                letterSpacing: -0.3,
              },
            ]}
          />
          {selectedOptions.map((option, index) => (
            <OptionCheckbox
              key={index}
              label={option.label}
              value={option.state}
              onValueChange={() => handleCheckboxChange(index)}
            />
          ))}
        </View>
      </View>
      <BottomView
        enableTitle={false}
        onPress={nextButtonHandle}
        disableBtn={selectedOptions.some(option => option.state)}
        style={{paddingBottom: 20}}
      />
    </SafeAreaView>
  );
};

export default LikeToDate;
